export const NEW_MESSAGE = "newMessage";
export const MESSAGE_DELETED = "messageDeleted";
